import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarX2, Trash2, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function CalendarMgmt() {
  const [rows, setRows] = useState([]);
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");

  const load = () => api.get("/admin/blocked-dates").then(({ data }) => setRows(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!date) return toast.error("Select a date");
    try { await api.post("/admin/blocked-dates", { date, reason }); toast.success("Date blocked"); setDate(""); setReason(""); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const remove = async (d) => { await api.delete(`/admin/blocked-dates/${d}`); toast.success("Unblocked"); load(); };

  return (
    <div>
      <h1 className="font-display text-3xl text-zinc-900 mb-1">Calendar Management</h1>
      <p className="text-zinc-600 text-sm mb-6">Block dates when you are unavailable. Customers can't book these.</p>

      <div className="bg-card border border-pink-200 rounded-xl p-5 mb-6 grid sm:grid-cols-[1fr_1fr_auto] gap-3 items-end">
        <div>
          <Label className="text-zinc-700">Date</Label>
          <Input type="date" value={date} data-testid="block-date-input" onChange={(e) => setDate(e.target.value)} className="mt-1 bg-white border-pink-200 text-zinc-900 [color-scheme:light]" />
        </div>
        <div>
          <Label className="text-zinc-700">Reason (optional)</Label>
          <Input value={reason} data-testid="block-reason-input" onChange={(e) => setReason(e.target.value)} className="mt-1 bg-white border-pink-200 text-zinc-900" />
        </div>
        <Button onClick={add} data-testid="add-block-btn" className="gold-gradient text-white font-semibold"><Plus size={16} className="mr-1" /> Block</Button>
      </div>

      <div className="bg-card border border-pink-200 rounded-xl divide-y divide-pink-100">
        {rows.map((r) => (
          <div key={r.date} className="flex items-center justify-between px-5 py-3" data-testid={`blocked-${r.date}`}>
            <div className="flex items-center gap-3"><CalendarX2 size={18} className="text-gold" /><span className="text-zinc-900">{r.date}</span><span className="text-sm text-zinc-500">{r.reason}</span></div>
            <button onClick={() => remove(r.date)} className="text-zinc-600 hover:text-red-400" data-testid={`unblock-${r.date}`}><Trash2 size={16} /></button>
          </div>
        ))}
        {rows.length === 0 && <div className="px-5 py-10 text-center text-zinc-500">No blocked dates</div>}
      </div>
    </div>
  );
}
